import { XMarkIcon } from "@heroicons/react/24/solid";
import ScreenWrapper from "../../components/common/ScreenWrapper";
import { useAppDispatch, useAppSelector } from "../../redux/store";
import { clearCart } from "../../redux/slice/cart-slice";
import CartItem from "./components/cart-item";
import AddCustomer from "./components/add-customer";

type Props = {};

const CartPage = (props: Props) => {
  const dispatch = useAppDispatch();
  const { cart } = useAppSelector((state) => state.cart);

  return (
    <ScreenWrapper title={"Cart"} showBackBtn>
      <div className="w-full max-w-2xl mx-auto bg-white min-h-screen mt-2 px-4 sm:px-6 lg:px-8">
        <div className="pt-12 flex justify-between items-center mb-4 rounded-2xl lg:max-w-7xl lg:mx-auto">
          <div className="flex items-center pt-6">
            <span className="text-base text-gray-800 font-medium">Items</span>
            <span className="text-base text-gray-800 font-medium">
              ({cart?.products?.length || 0})
            </span>
          </div>
          {cart?.products && cart.products.length > 0 && (
            <button
              type="button"
              className="text-sm p-2 rounded-lg cursor-pointer text-red-700 bg-red-100 flex items-center mt-6"
              onClick={() => dispatch(clearCart())}
            >
              <XMarkIcon className="h-4 w-4 mr-1" />
              Clear cart
            </button>
          )}
        </div>

        <div className="bg-primary-100 rounded-2xl mx-4">
          {(!cart || !cart.products || cart.products.length === 0) && (
            <div className="flex items-center justify-center w-full lg:max-w-7xl lg:mx-auto py-12">
              <div className="flex flex-col items-center">
                <span className="text-4xl mb-2">🥺</span>
                <span className="text-gray-800 text-base">
                  Your cart is empty
                </span>
              </div>
            </div>
          )}

          {cart?.products && cart.products.length > 0 && (
            <div className="mx-4 pt-4 lg:max-w-7xl lg:mx-auto">
              {cart.products
                .filter((item) => item != null)
                .map((item, idx) => (
                  <CartItem
                    product={item}
                    key={item.productSKU || idx}
                  />
                ))}
            </div>
          )}

          {cart?.products && cart.products.length > 0 && (
            <div className="mx-4 mt-4 lg:max-w-7xl lg:mx-auto">
              <AddCustomer />
            </div>
          )}
        </div>
      </div>
    </ScreenWrapper>
  );
};

export default CartPage;
